import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import ApiService from '../../services/apiService';
import { toast } from 'react-toastify';
import { RxCross1 } from 'react-icons/rx';
import { useSelector, useDispatch } from 'react-redux';
import { setRows, addRow, removeRow, removeSingleRow, updateRow, clearRows } from '../../../Redux/actions/rowActions';
import { IoAddSharp } from 'react-icons/io5';
import { BarLoader } from 'react-spinners';
import AsyncSelect from 'react-select/async';
import {
  PO_ITEM_COL,
  poCompactSelectStyles,
  getDefaultVatOption,
  resolveRowVat,
  resolveVatForItem,
  getVatSelectValue,
  mapVatSelectOptions,
} from './poItemGridColumns';

const UpdateItemGrid = ({ onRequisitionData, setLoader, loder, itemData, selectedCheck, handleVatChange, isDiscountPercentage,
  setOverallDiscount, grandTotal, setVatAmount, vatAmount, setDiscountInputType, discountInputType,
  overallDiscount, setDiscountAmount, discountAmount, setGrandTotal, exchangeRate, currencyChangeVersion }) => {
  const rows = useSelector((state) => state.rows.rows);
  const [itemOptions, setItemOptions] = useState([]);
  const [descriptionOptions, setDescriptionOptions] = useState([]);
  const [vat, setvat] = useState([]);
  const dispatch = useDispatch();
  const apiService = new ApiService();
  const [currencyPrecision, setCurrencyPrecision] = useState(3);

  const [page, setPage] = useState(1);
  const [desPage, setDecPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loader, setLoaders] = useState(false);
  const [overallDiscountAmount, setOverallDiscountAmount] = useState(); // Amount 

  const [columnWidths, setColumnWidths] = useState({
    remove: 40,
    srNo: 80,
    itemNo: 150,
    description: 300,
    specification: 150,
    qty: 100,
    unitPrice: 120,
    discount: 120,
    calculatedAmount: 180,
    vat: 100,
    vatAmount: 160,
    amount: 140,
    inventoryQty: 140,
    lastPurchasePrice: 180
  });
  const calculatedTotal = rows.reduce((sum, row) => {
    const amount = parseFloat(row?.amount) || 0;
    const vatAmount = parseFloat(row?.vatAmount) || 0;
    const discount = parseFloat(row?.discount) || 0;
    let final = overallDiscount === 0 || overallDiscount === "0.000" ? ((amount + discount) - vatAmount) : (amount - vatAmount)

    return sum + (final);
  }, 0);

  const totalItemDiscount = rows.reduce((sum, row) => { return sum + Number(row?.discount || 0); }, 0);
  // useEffect(() => {
  //   if (rows[0]?.ItemNo) {
  //     updatevat();
  //   }
  // }, [selectedCheck]);
  // Replace the existing useEffects in ItemGrid with these:

  useEffect(() => {
    fetchItemNo('', 1);
    fetchItemDesc('', 1);
    getVat();
  }, []);

  // Clear rows when itemData changes (important for dropdown changes)
  useEffect(() => {
    if (itemData?.requisitionNo) {
      // Clear existing rows when new itemData comes in
      dispatch(clearRows());
      setRows([]);
    }
  }, [itemData?.requisitionNo]); // React to requisition number changes

  // Process items when all dependencies are ready
  useEffect(() => {
    if (itemData) {
      getItems();
    }
  }, [itemData, isDiscountPercentage]); // Add all necessary dependencies

  // Convert prices only after the user explicitly changes the currency.
  // Do not convert during initial page load or when a user edits a unit price.
  const previousCurrencyChangeVersion = useRef(currencyChangeVersion);
  useEffect(() => {
    if (previousCurrencyChangeVersion.current === currencyChangeVersion) return;
    previousCurrencyChangeVersion.current = currencyChangeVersion;

    const rate = Number(exchangeRate);
    if (!Number.isFinite(rate) || rate <= 0 || !rows.length) return;

    const updatedRows = rows.map((row) => {
      const originalUnitPrice =
        row.originalUnitPrice !== undefined && row.originalUnitPrice !== null && row.originalUnitPrice !== ''
          ? Number(row.originalUnitPrice)
          : Number(row.baseAmount || 0);
      const unitPrice = originalUnitPrice * rate;
      const qty = Number(row.qty || 0);
      const discount = Number(row.discount || 0);
      const grossAmount = qty * unitPrice;
      const calculatedAmount = grossAmount - discount;
      const vatRate = Number(row.vat || 0);
      const calculatedVatAmount = (calculatedAmount * vatRate) / 100;
      const rowVatAmount = row?.isVatManuallyEntered
        ? Number(row.vatAmount || 0)
        : calculatedVatAmount;
      debugger
      return {
        ...row,
        originalUnitPrice,
        baseAmount: Number(unitPrice.toFixed(4)),
        calculatedAmount: Number(calculatedAmount.toFixed(currencyPrecision || 3)),
        discountAmount: Number(calculatedAmount.toFixed(currencyPrecision || 3)),
        vatAmount: Number(rowVatAmount.toFixed(currencyPrecision || 3)),
        amount: Number((calculatedAmount + rowVatAmount).toFixed(currencyPrecision || 3)),
      };
    });

    dispatch(setRows(updatedRows));
    onRequisitionData(updatedRows);
    // Conversion is explicitly triggered by the parent currency-change event.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currencyChangeVersion]);

  useEffect(() => {
    const grossAmount = rows.reduce(
      (sum, row) => sum + Number(row?.amount || 0),
      0
    );

    let discountAmt;

    if (discountInputType === "amount") {
      discountAmt = Number(overallDiscountAmount || 0);
    } else if (discountInputType === "percentage") {
      discountAmt =
        (calculatedTotal * Number(overallDiscount || 0)) / 100;
    } else {
      discountAmt = totalItemDiscount;
    }

    const afterDiscount = calculatedTotal - (discountAmt);

    // ---------------- VAT Calculation ----------------

    let vatAmount = 0;
    if (rows.some((row) => row?.isVatManuallyEntered === true)) {
      vatAmount = rows.reduce((sum, row) => sum + Number(row?.vatAmount || 0), 0);
    } else if (rows.length === 1) {
      const vatRate = rows[0]?.vat;
      vatAmount = (afterDiscount * vatRate) / 100;


      // vatAmount = rows.reduce(
      //   (sum, row) => sum + Number(row?.vatAmount || 0),
      //   0
      // );
    } else {
      // Get unique VAT rates
      const uniqueVatRates = [
        ...new Set(rows.map((r) => Number(r?.vat || 0))),
      ];
      if (uniqueVatRates.length === 1) {
        // Same VAT on all rows
        const vatRate = uniqueVatRates[0];
        const vatAmoun = (afterDiscount * vatRate) / 100;
        vatAmount = Number(vatAmoun?.toFixed(currencyPrecision || 3))
      } else {
        // Different VAT rates
        vatAmount = rows.reduce(
          (sum, row) => sum + parseFloat(row?.vatAmount || 0),
          0
        );
      }
    }

    // -------------------------------------------------

    const grandTotal = afterDiscount + vatAmount;
    setDiscountAmount(Number(discountAmt?.toFixed(3)));
    setVatAmount(vatAmount);
    setGrandTotal(Number(grandTotal?.toFixed(3)));

    setOverallDiscountAmount(Number(discountAmt?.toFixed(3)));

  }, [
    rows,
    overallDiscount,
    overallDiscountAmount,
    discountInputType
  ]);

  const updatevat = async () => {
    try {
      let vatParam = `?toPurchase=true`;
      const vat = await apiService.getApiParamater('GET_INV_TAX', vatParam);
      setvat(vat.data.result);

      const updatedRows = rows.map((row) => ({ ...row }));
      const apiPromises = updatedRows.map(async (row, index) => {
        const { rate: vatRate, description: vatDescription } = resolveRowVat(vat.data.result, row?.vatDec);

        const gross = Number(row.qty || 0) * Number(row.baseAmount || 0);
        const discount = Number(row?.discount || 0);
        const afterDiscount = gross - discount;
        const vatAmount = afterDiscount * Number(vatRate || 0) / 100;
        const finalAmount = afterDiscount + vatAmount;
        updatedRows[index].calculatedAmount = gross?.toFixed(currencyPrecision || 3);
        updatedRows[index].discountAmount = afterDiscount;
        updatedRows[index].amount = finalAmount;
        updatedRows[index].vat = vatRate;
        updatedRows[index].vatDec = vatDescription;
        updatedRows[index].isVatManuallyEntered = false;
        updatedRows[index].vatAmount = vatAmount;
      });
      await Promise.all(apiPromises);
      setRows(updatedRows);
      onRequisitionData(updatedRows);
      dispatch(setRows(updatedRows));
    } catch (error) {
      console.error('Error updating rows with new stock:', error);
    }
  };
  const getVat = async () => {
    let vatParam = `?toPurchase=true`;
    const vat = await apiService.getApiParamater('GET_INV_TAX', vatParam);
    setvat(vat.data.result);
  };
  const getItems = async () => {
    try {
      let vatParam = `?toPurchase=true`;
      const vat = await apiService.getApiParamater('GET_INV_TAX', vatParam);
      setvat(vat.data.result);

      if (itemData?.requisitionNo) {
        setLoader(true);
        let param = `?Id=${itemData?.requisitionNo}`;
        const response = await apiService.getApiParamater('GET_PR', param);
        const selectedPR = response?.data?.result[0];
        if (!selectedPR) {
          console.error('Selected PR not found');
          return;
        }
        const prDetails = selectedPR?.prDetails || [];
        const formattedRowsPromises = itemData?.poDetails
          ?.map(async (detail, index) => {
            const params = new URLSearchParams();
            params.append('ItemNo', detail.itemCode || '');
            const response = await apiService.getApiParamater('GET_ITEM_PACK', `?${params.toString()}`);
            let selecteditem = response?.data?.result[0];
            const selectedItem = rows?.find((item) => item?.itemDescription === detail?.itemDescription);
            const selectedPritem = prDetails?.find((item) => item.itemCode === detail.itemCode);
            const selectedVat = vat.data.result.find((tax) => tax.description === detail?.vatDesc);
            if (!selecteditem) {
              console.error(`Selected item with description ${detail?.itemDescription} not found`);
              return null;
            }

            const grossAmount = (detail.qty) * (detail.unitPrice);
            const itemDiscount = (detail?.discount || 0);
            const afterDiscount = grossAmount - itemDiscount;
            const vatAmount = afterDiscount * (selectedVat?.rate || 0) / 100;
            debugger
            return {
              _rowKey: `po-row-${index}-${detail?.srno ?? ''}-${Date.now()}`,
              requisitionNo: itemData.requisitionNo || '',
              rsrno: parseInt(detail?.rsrno),
              srno: parseInt(detail?.srno),
              ItemNo: detail.itemCode,
              itemDescription: detail?.itemDescription,
              qty: detail?.qty,
              stock: selecteditem.convToInvUOM * detail?.qty,
              baseQty: selecteditem.convToInvUOM,
              uom: detail?.uom,
              baseAmount: detail.unitPrice ?? 0,
              originalUnitPrice: detail.unitPrice ?? 0,
              specification: detail?.specification || '',
              amount: detail?.amount ?? 0,
              vat: selectedVat?.rate ?? 0,
              vatDec: selectedVat?.description ?? '',
              vatAmount: vatAmount ?? 0,
              isVatManuallyEntered: false,
              discount: detail?.discount,
              calculatedAmount: afterDiscount?.toFixed(currencyPrecision || 3),
              discountAmount: Number(detail?.amount ?? 0) - Number(detail?.vatAmount ?? 0),
              avgPrice: selecteditem?.avgPrice?.toFixed(currencyPrecision || 3) || 0

            };
          })
          .filter((row) => row !== null);
        const formattedRows = await Promise.all(formattedRowsPromises);
        if (formattedRows?.length > 0) {
          setLoader(false);
          setRows(formattedRows?.reverse());
          onRequisitionData(formattedRows);
          dispatch(setRows(formattedRows));
        }
      } else {
        setLoader(true);
        const formattedRowsPromises = itemData?.poDetails
          ?.map(async (detail, index) => {
            const params = new URLSearchParams();
            params.append('ItemNo', detail.itemCode || '');
            const response = await apiService.getApiParamater('GET_ITEM', `?${params.toString()}`);
            let selecteditem = response?.data?.result[0];

            const selectedItem = rows?.find((item) => item?.itemDescription === detail?.itemDescription);
            const selectedVat = vat.data.result.find((tax) => tax.description === detail?.vatDesc);

            const grossAmount = (detail.qty) * (detail.unitPrice);
            const itemDiscount = (detail?.discount || 0);
            const afterDiscount = grossAmount - itemDiscount;
            const vatAmount = afterDiscount * (selectedVat?.rate || 0) / 100;
            const finalAmount = afterDiscount + vatAmount;
            debugger
            return {
              _rowKey: `po-row-${index}-${detail?.srno ?? ''}-${Date.now()}`,
              requisitionNo: itemData?.requisitionNo || '',
              srno: detail?.srno,
              rsrno: parseInt(detail?.rsrno),
              ItemNo: detail.itemCode,
              itemDescription: detail?.itemDescription,
              qty: detail?.qty,
              stock: selecteditem.convToInvUOM * detail?.qty,
              baseQty: selecteditem.convToInvUOM,
              uom: detail?.uom,
              baseAmount: detail.unitPrice ?? 0,
              originalUnitPrice: detail.unitPrice ?? 0,
              specification: detail ? detail?.specification : '',
              amount: detail?.amount ?? 0,
              vat: selectedVat?.rate ?? 0,
              vatDec: selectedVat?.description ?? '',
              vatAmount: vatAmount ?? 0,
              isVatManuallyEntered: false,
              discount: detail?.discount,
              calculatedAmount: afterDiscount?.toFixed(currencyPrecision || 3),
              discountAmount: Number(detail?.amount ?? 0) - Number(vatAmount ?? 0),
              avgPrice: selecteditem?.avgPrice?.toFixed(currencyPrecision || 3) || 0
            };
          })
          .filter((row) => row !== null);
        const formattedRows = await Promise.all(formattedRowsPromises);
        if (formattedRows?.length > 0) {
          setLoader(false);
          setRows(formattedRows);
          onRequisitionData(formattedRows);
          dispatch(setRows(formattedRows));
        }
      }
    } catch (error) {
      setLoader(false);
      console.error('Error fetching items:', error);
    }
  };
  const fetchItemNo = async (inputValue = '', pageNumber = 1) => {
    if (loader) return;
    setLoaders(true);
    try {
      const apiService = new ApiService();
      const params = new URLSearchParams();
      params.append('PageNo', pageNumber || 1);
      params.append('PageSize', 20);
      params.append('ItemNo', inputValue || '');
      const response = await apiService.getApiParamater('GET_ITEM', `?${params.toString()}`);
      const fetchedItems = response.data.result.map((item) => ({
        label: item.itemNo,
        value: item,
      }));
      if (fetchedItems.length < 20) setHasMore(false);
      setItemOptions((prevAccounts) => [...prevAccounts, ...fetchedItems]);
      setLoaders(false);
      return fetchedItems;
    } catch (error) {
      console.error('Error fetching account data:', error);
      setLoaders(false);
      return [];
    }
  };
  const fetchItemDesc = async (inputValue = '', pageNumber = 1) => {
    if (loader) return;
    setLoaders(true);
    try {
      const apiService = new ApiService();
      const params = new URLSearchParams();
      params.append('PageNo', pageNumber || 1);
      params.append('PageSize', 20);
      params.append('ItemDescription', inputValue || '');
      const response = await apiService.getApiParamater('GET_ITEM', `?${params.toString()}`);
      const fetchedItems = response.data.result.map((item) => ({
        label: item.itemDescription,
        value: item,
      }));
      if (fetchedItems.length < 20) setHasMore(false);
      setDescriptionOptions((prevAccounts) => [...prevAccounts, ...fetchedItems]);
      setLoaders(false);
      return fetchedItems;
    } catch (error) {
      console.error('Error fetching account data:', error);
      setLoaders(false);
      return [];
    }
  };
  const loadOptions = async (inputValue, callback) => {
    const options = await fetchItemNo(inputValue, 1);
    callback(options);
  };
  const loadDescOptions = async (inputValue, callback) => {
    const options = await fetchItemDesc(inputValue, 1);
    callback(options);
  };
  const loadMoreOptions = async () => {
    if (!hasMore || loader) return;
    setPage((prevPage) => prevPage + 1);
    await fetchItemNo('', page + 1);
  };
  const loadMoreDescOptions = async () => {
    if (!hasMore || loader) return;
    setDecPage((prevPage) => prevPage + 1);
    await fetchItemDesc('', desPage + 1);
  };
  const addNewRow = () => {
    const defaultVat = getDefaultVatOption(vat);
    const newRow = {
      _rowKey: `po-row-new-${Date.now()}-${Math.random().toString(36).slice(2)}`,
      srno: '',
      ItemNo: '',
      requisitionNo: '',
      itemDescription: '',
      branch: '',
      qty: '',
      uom: '',
      baseQty: '',
      baseAmount: '',
      originalUnitPrice: '',
      amount: '',
      stock: '',
      bol: '',
      vat: defaultVat?.rate ?? 0,
      vatDec: defaultVat?.description ?? '',
      vatAmount: 0,
      isVatManuallyEntered: false,
    };
    dispatch(addRow(newRow));
    const updatedRows = [...rows, newRow];
    onRequisitionData(updatedRows);
    dispatch(setRows(updatedRows));
  };
  const handleRemoveRow = (srno) => {
    const indexToRemove = rows.findIndex(row => row.srno === srno);
    dispatch(removeSingleRow(indexToRemove));
    const updatedRows = rows
      .filter((row) => row.srno !== srno)
      .map((row, i) => ({
        ...row,
        srno: i + 1,
      }));
    onRequisitionData(updatedRows);
    dispatch(setRows(updatedRows));
    setRows(updatedRows);
  };
  const preventNegativeSign = (e) => {
    if (e.key === '-' || e.key === '+') {
      e.preventDefault();
    }
  };
  const handleFreeQTChange = (srno, value) => {
    const newQty = value || 0;
    const index = rows.findIndex(row => row.srno === srno);
    const balQty = rows[index].balQty;
    const qty = rows[index].qty || 0;

    if (newQty < 0) {
      toast.warning('Quantity cannot be less than 0.');
      return;
    }

    setRows((prevRows) => {
      const newRows = [...prevRows];
      newRows[index].freeQty = newQty;
      return newRows;
    });
  };
  const handleOverallDiscountAmount = (e) => {

    const amount = Number(e.target.value) || 0;
    const hasItemDiscount = rows.some(row => Number(row?.discount || 0) > 0);
    const hasSameVat = rows.some(row => Number(row?.vatDec || 0) > 0);
    if (hasItemDiscount) {
      toast.warning("Clear item discounts before applying overall discount.");
      return;
    }
    if (amount > calculatedTotal) {
      toast.warning("Discount amount cannot exceed total.");
      return;
    }
    const percentage = calculatedTotal === 0 ? 0 : (amount / calculatedTotal) * 100;

    if (percentage > 100) {
      toast.warning("Discount percentage cannot exceed 100%");
      return;
    }
    const total = rows.reduce((sum, row) => sum + Number(row?.amount - row?.vatAmount || 0), 0);
    const discountAmt = (calculatedTotal * percentage) / 100;
    if (discountAmt > total) {
      toast.warning("Discount amount cannot exceed total amount");
      return;
    }
    let calculatedfinal = selectedCheck === true ? calculatedTotal : total
    let afterdiscount = (calculatedTotal - discountAmt)
    let vatAmt = 0;

    if (rows.some((row) => row?.isVatManuallyEntered === true)) {
      vatAmt = rows.reduce((sum, row) => sum + Number(row?.vatAmount || 0), 0);
    } else if (rows.length === 1) {
      vatAmt = (afterdiscount * Number(rows[0]?.vat || 0)) / 100;
    } else {
      const uniqueVatRates = [...new Set(rows.map(r => Number(r?.vat || 0)))];

      if (uniqueVatRates.length === 1) {
        vatAmt = (afterdiscount * uniqueVatRates[0]) / 100;
      } else {
        vatAmt = rows.reduce(
          (sum, row) => sum + Number(row?.vatAmount || 0),
          0
        );
      }
    }
    const grandtotals = (afterdiscount + vatAmt)
    const grandtotalsvat = (afterdiscount + vatAmt)
    let final = percentage === 0 ? grandtotalsvat : grandtotals
    setDiscountInputType(amount === 0 ? "" : "amount");
    setDiscountAmount(discountAmt);
    setGrandTotal(final);
    setVatAmount(vatAmt)
    setOverallDiscount(percentage?.toFixed(3))
    setOverallDiscountAmount(e.target.value);
  };
  const handleOverallDiscount = (e) => {
    const percentage = Number(e.target.value) || 0;
    if (percentage > 100) {
      toast.warning("Discount percentage cannot exceed 100%");
      return;
    }
    const total = rows.reduce((sum, row) => sum + Number(row?.amount - row?.vatAmount || 0), 0);
    const discountAmt = (calculatedTotal * percentage) / 100;
    if (discountAmt > total) {
      toast.warning("Discount amount cannot exceed total amount");
      return;
    }
    let calculatedfinal = selectedCheck === true ? calculatedTotal : total
    let afterdiscount = (calculatedTotal - discountAmt)
    let vatAmt = 0;

    if (rows.some((row) => row?.isVatManuallyEntered === true)) {
      vatAmt = rows.reduce((sum, row) => sum + Number(row?.vatAmount || 0), 0);
    } else if (rows.length === 1) {
      vatAmt = (afterdiscount * Number(rows[0]?.vat || 0)) / 100;
    } else {
      const uniqueVatRates = [...new Set(rows.map(r => Number(r?.vat || 0)))];

      if (uniqueVatRates.length === 1) {
        vatAmt = (afterdiscount * uniqueVatRates[0]) / 100;
      } else {
        vatAmt = rows.reduce(
          (sum, row) => sum + Number(row?.vatAmount || 0),
          0
        );
      }
    }
    const grandtotals = (afterdiscount + vatAmt)
    const grandtotalsvat = (afterdiscount + vatAmt)
    let final = percentage === 0 ? grandtotalsvat : grandtotals
    setDiscountInputType(percentage === 0 ? "" : "percentage");
    setDiscountAmount(discountAmt);
    setGrandTotal(final);
    setVatAmount(vatAmt)
    setOverallDiscount(percentage)
    setOverallDiscountAmount(discountAmt);
  };
  const ResizableHeader = ({ column, children }) => {
    return (
      <th
        style={{
          width: `${columnWidths[column]}px`,
          minWidth: `${columnWidths[column]}px`,
          position: 'relative'
        }}
      >
        {children}

        <span
          className="resize-handle"
          onMouseDown={(e) => startResize(e, column)}
        />
      </th>
    );
  };
  const startResize = (e, column) => {
    e.preventDefault();

    const startX = e.clientX;
    const startWidth = columnWidths[column];

    const handleMouseMove = (event) => {
      const newWidth = Math.max(
        50,
        startWidth + (event.clientX - startX)
      );

      setColumnWidths(prev => ({
        ...prev,
        [column]: newWidth
      }));
    };

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };
  const handleQtyKeyDown = (e, index) => {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      const nextIndex = index + 1;
      if (nextIndex < rows.length) {
        const nextInput = document.getElementById(`qty-${nextIndex}`);
        if (nextInput) {
          nextInput.focus();
          nextInput.select();
        }
      }
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      const prevIndex = index - 1;
      if (prevIndex >= 0) {
        const prevInput = document.getElementById(`qty-${prevIndex}`);
        if (prevInput) {
          prevInput.focus();
          prevInput.select();
        }
      }
    } else if (e.key === '-' || e.key === '+') {
      e.preventDefault();
    }
  };

  const handleInputChange = async (rowKey, index, fieldName, value) => {
    if (fieldName === "specification") {
      const updatedRows = rows.map((row, i) => {
        if (row._rowKey ? row._rowKey === rowKey : i === index) {
          return {
            ...row,
            specification: value,
            srno: row.srno || index + 1,
          };
        }

        return row;
      });

      setRows(updatedRows);
      dispatch(setRows(updatedRows));
      onRequisitionData(updatedRows);
      return;
    }

    const updatedRows = await Promise.all(
      rows.map(async (row, i) => {
        // Match using index first, srno as fallback
        if (row._rowKey ? row._rowKey !== rowKey : i !== index) {
          return row;
        }

        const manuallyEnteredVatAmount = row?.vatAmount;
        let updatedRow = {
          ...row,
          [fieldName]: value,
          srno: row.srno || index + 1,
        };
        if (fieldName === "discount") {
          const grossAmount =
            Number(updatedRow.qty || 0) * Number(updatedRow.baseAmount || 0);

          const discount = Number(value || 0);

          if (overallDiscount > 0) {
            toast.warning("Overall discount already applied. Clear it first.");
            return row;
          }

          if (discount > grossAmount) {
            toast.warning("Discount cannot exceed Amount.");
            return row;
          }
        }
        if (fieldName === 'ItemNo') {
          const getunit = await apiService.getApiParamater('GET_ITEM_PACK', `?ItemNo=${value}`);
          let selectedItem = getunit?.data?.result[0];
          const selectedVat = resolveVatForItem(vat, selectedItem?.vat);
          if (selectedItem) {
            updatedRow.itemDescription = selectedItem?.itemDescription;
            updatedRow.ItemNo = selectedItem?.itemNo;
            updatedRow.requisitionNo = selectedItem?.itemDescription;
            updatedRow.uom = selectedItem.baseUnit;
            updatedRow.specification = selectedItem?.specification;
            updatedRow.vatDec = selectedVat?.description ?? '';
            updatedRow.vat = selectedVat?.rate ?? 0;
            updatedRow.isVatManuallyEntered = false;
            updatedRow.stock = 0;
            updatedRow.discount = 0;
            updatedRow.baseAmount = 0;
            updatedRow.avgPrice = selectedItem?.avgPrice?.toFixed(currencyPrecision || 3) || 0;
            updatedRow.baseQty = parseFloat(selectedItem.convToInvUOM);
          }
        } else if (fieldName === 'itemDescription') {
          const getunit = await apiService.getApiParamater('GET_ITEM_PACK', `?ItemDescription=${value}`);
          let selectedItem = getunit?.data?.result[0];

          const selectedVat = resolveVatForItem(vat, selectedItem?.vat);
          if (selectedItem) {
            updatedRow.specification = selectedItem?.specification;
            updatedRow.recordId = selectedItem?.itemNo;
            updatedRow.itemDescription = selectedItem?.itemDescription;
            updatedRow.ItemNo = selectedItem?.itemNo;
            updatedRow.discount = 0;
            updatedRow.stock = 0;
            updatedRow.uom = selectedItem.baseUnit;
            updatedRow.baseQty = parseFloat(selectedItem.convToInvUOM);
            updatedRow.vatDec = selectedVat?.description ?? '';
            updatedRow.vat = selectedVat?.rate ?? 0;
            updatedRow.isVatManuallyEntered = false;
            updatedRow.baseAmount = 0;
            updatedRow.avgPrice = selectedItem?.avgPrice?.toFixed(currencyPrecision || 3) || 0;
          }
        }
        if (fieldName === 'qty') {

          const quantity = parseFloat(value);
          const convrate = row?.baseQty;
          const { rate: vatRate } = resolveRowVat(vat, row?.vatDec);
          const discount = row?.discount;
          const unitPrice = parseFloat(row.baseAmount || value || 0);
          let amount = quantity * unitPrice;
          let discountA = parseFloat(amount - (row?.discount || 0))
          let discountAmt = discountA?.toFixed(currencyPrecision || 3)
          const perAmount = parseFloat((discountAmt / 100) * vatRate);
          let vatAMount = perAmount?.toFixed(currencyPrecision || 3)
          let excludedAmount = parseFloat(discountAmt) + parseFloat(vatAMount);
          const calculatedAmount = excludedAmount?.toFixed(currencyPrecision || 3);
          updatedRow.amount = calculatedAmount;
          updatedRow.calculatedAmount = discountAmt;
          updatedRow.stock = convrate * quantity || 0;
          updatedRow.vatAmount = vatAMount;
          updatedRow.baseQty = parseFloat(convrate);
          updatedRow.qty = quantity;
          updatedRow.baseAmount = unitPrice;

        }
        if (fieldName === 'discount') {
          const discount = parseFloat(value);
          const unitPrice = parseFloat(row.baseAmount);

          const grossAmount = Number(row.qty || 0) * Number(row.baseAmount || 0);
          let itemDiscount = Number(discount || 0);

          const afterDiscount = grossAmount - itemDiscount;
          const vatRate = Number(row.vat || 0);
          const vatAmount = parseFloat(afterDiscount * vatRate / 100);
          let vatAMount = vatAmount?.toFixed(currencyPrecision || 3)
          const finalAmount = parseFloat(afterDiscount) + parseFloat(vatAMount);
          updatedRow.calculatedAmount = afterDiscount?.toFixed(currencyPrecision || 3);
          updatedRow.discountAmount = afterDiscount;
          updatedRow.vatAmount = vatAMount || 0;
          updatedRow.amount = finalAmount;
          updatedRow.discount = discount || 0

        }
        if (fieldName === 'baseAmount') {

          const convrate = row?.baseQty;
          const { rate: vatRate } = resolveRowVat(vat, row?.vatDec);
          const quantity = parseFloat(row?.qty || value);
          const discount = parseFloat(row?.discount) || 0;
          // Keep exactly the price the user entered. Currency conversion is
          // performed only when the user explicitly changes the currency.
          const originalUnitPrice = parseFloat(value || 0);
          const unitPrice = originalUnitPrice;
          let amount = parseFloat(quantity) * parseFloat(unitPrice);
          let discountA = parseFloat(amount - (discount || 0))

          let discountAmt = discountA?.toFixed(currencyPrecision || 3)
          const perAmount = parseFloat((discountAmt / 100) * vatRate);
          let vatAMount = perAmount?.toFixed(currencyPrecision || 3)
          let excludedAmount = parseFloat(discountAmt) + parseFloat(vatAMount);
          const calculatedAmount = excludedAmount;
          updatedRow.stock = convrate * quantity || 0;
          updatedRow.qty = quantity;
          updatedRow.originalUnitPrice = originalUnitPrice;
          updatedRow.baseAmount = unitPrice;
          updatedRow.amount = calculatedAmount?.toFixed(currencyPrecision || 3);
          updatedRow.calculatedAmount = discountAmt;
          updatedRow.vatAmount = vatAMount || 0;

        }
        if (fieldName === 'vatAmount') {
          const hasManualVatValue = value !== '' && value !== null && value !== undefined;
          const manualVatAmount = Number(value || 0);
          updatedRow.isVatManuallyEntered = hasManualVatValue;
          if (hasManualVatValue) {
            updatedRow.vatAmount = value;
            updatedRow.amount = (Number(updatedRow.calculatedAmount || 0) + manualVatAmount)
              .toFixed(currencyPrecision || 3);
          } else {
            const automaticVatAmount = Number(updatedRow.calculatedAmount || 0) * Number(updatedRow.vat || 0) / 100;
            updatedRow.vatAmount = automaticVatAmount.toFixed(currencyPrecision || 3);
            updatedRow.amount = (Number(updatedRow.calculatedAmount || 0) + automaticVatAmount)
              .toFixed(currencyPrecision || 3);
          }
        }
        if (fieldName === 'vat') {
          const amount = parseFloat(row?.calculatedAmount) || 0;

          // let amount = parseFloat(row?.qty) * parseFloat(row?.baseAmount);
          let discountA = parseFloat(amount - (row?.discount || 0))
          let discountamt = discountA?.toFixed(currencyPrecision || 3)

          const perAmount = parseFloat(discountamt / 100) * parseFloat(value?.rate || 0);
          const vat = perAmount?.toFixed(currencyPrecision || 3);
          let excludedAmount = parseFloat(discountamt) + parseFloat(vat);
          const calculatedAmount = excludedAmount;
          updatedRow.vatDec = value?.description;
          updatedRow.vat = value?.rate;
          updatedRow.isVatManuallyEntered = false;
          updatedRow.calculatedAmount = discountamt?.toFixed(currencyPrecision || 3);
          updatedRow.amount = calculatedAmount;
          updatedRow.vatAmount = vat || 0;

        }
        if (fieldName === "calculatedAmount") {
          const calculatedAmount = parseFloat(value) || 0;
          const vatRate = Number(updatedRow?.vat || 0);

          // const vatAmount = truncateAmount(
          //   (calculatedAmount * vatRate) / 100,
          //   currencyPrecision || 3
          // );
          let vatAmount = (calculatedAmount * vatRate) / 100;
          const finalAmount = truncateAmount(
            calculatedAmount + vatAmount,
            currencyPrecision || 3
          );

          updatedRow.calculatedAmount = calculatedAmount;
          if (updatedRow.isVatManuallyEntered) {
            updatedRow.vatAmount = manuallyEnteredVatAmount;
            updatedRow.amount = (Number(calculatedAmount || 0) + Number(manuallyEnteredVatAmount || 0))
              .toFixed(currencyPrecision || 3);
          } else {
            updatedRow.vatAmount = vatAmount?.toFixed(currencyPrecision || 3);
            updatedRow.amount = finalAmount?.toFixed(currencyPrecision || 3);
          }

          return updatedRow;
        }
        if (updatedRow.isVatManuallyEntered && !["vatAmount", "vat"].includes(fieldName)) {
          updatedRow.vatAmount = manuallyEnteredVatAmount;
          updatedRow.amount = (Number(updatedRow.calculatedAmount || 0) + Number(manuallyEnteredVatAmount || 0))
            .toFixed(currencyPrecision || 3);
        }
        return updatedRow;
      })
    );

    setRows(updatedRows);
    dispatch(setRows(updatedRows));
    onRequisitionData(updatedRows);
  };
  const truncateAmount = (value, decimals = 3) => {
    const num = Number(value) || 0;
    const factor = Math.pow(10, decimals);

    return Math.trunc(num * factor) / factor;
  };
  return (
    <div>
      <div className="row mb-3">
        <div className="col-md-4">
          <label>Discount %</label>
          <input
            type="number"
            className="form-control"
            value={overallDiscount}
            onKeyDown={preventNegativeSign}
            onChange={handleOverallDiscount}
            disabled={
              rows.some(
                x => Number(x?.discount) > 0
              )
            }
          />
        </div>
        <div className="col-md-4">
          <label>Discount Amount</label>
          <input
            type="number"
            className="form-control"
            value={overallDiscountAmount}
            onKeyDown={preventNegativeSign}
            onChange={handleOverallDiscountAmount}
            disabled={
              rows.some(
                x => Number(x?.discount) > 0
              )
            }
          />
        </div>
      </div>
      <div className="table-container p-2 mb-5" style={{ overflowX: 'auto', height: '400px' }}>
        {loder === true ? (
          <div className="center p-5">
            <BarLoader color="#6E5199" size={50} height={3} width={300} />
          </div>
        ) : (
          <table>
            <thead className="dynoTable">
              <tr>
                <ResizableHeader column="remove">
                  <span></span>
                </ResizableHeader>

                <ResizableHeader column="srNo">
                  Sr no
                </ResizableHeader>

                <ResizableHeader column="itemNo">
                  Item No
                </ResizableHeader>

                <ResizableHeader column="description">
                  Description
                </ResizableHeader>

                <ResizableHeader column="specification">
                  Item Specs
                </ResizableHeader>

                <ResizableHeader column="qty">
                  Qty
                </ResizableHeader>

                <ResizableHeader column="unitPrice">
                  Unit Price
                </ResizableHeader>

                <ResizableHeader column="discount">
                  Discount
                </ResizableHeader>

                <ResizableHeader column="calculatedAmount">
                  Calculated Amount
                </ResizableHeader>

                <ResizableHeader column="vat">
                  VAT %
                </ResizableHeader>

                <ResizableHeader column="vatAmount">
                  VAT Amount
                </ResizableHeader>

                <ResizableHeader column="amount">
                  Amount
                </ResizableHeader>

                <ResizableHeader column="inventoryQty">
                  Inventory Qty
                </ResizableHeader>

                <ResizableHeader column="lastPurchasePrice">
                  Last Purchase Price
                </ResizableHeader>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(rows) && [...rows].sort((a, b) => Number(a.srno) - Number(b.srno)).map((row, index) => (
                <tr key={row._rowKey || `${row.srno}-${index}`}>

                  {/* Remove */}
                  <td
                    className="m-0 p-0"
                    style={{
                      width: `${columnWidths.remove}px`,
                      minWidth: `${columnWidths.remove}px`,
                      border: "1px solid rgba(118, 118, 118, 0.3)"
                    }}
                  >
                    <div
                      className="center"
                      onClick={() => handleRemoveRow(row.srno)}
                    >
                      <RxCross1 size={15} />
                    </div>
                  </td>

                  {/* Sr No */}
                  <td
                    className="m-0 p-0"
                    style={{
                      width: `${columnWidths.srNo}px`,
                      minWidth: `${columnWidths.srNo}px`
                    }}
                  >
                    <input
                      className="p-2"
                      type="text"
                      value={row?.srno}
                      disabled
                      style={{
                        width: "100%",
                        boxSizing: "border-box"
                      }}
                    />
                  </td>

                  {/* Item No */}
                  <td
                    className="m-0 p-0"
                    style={{
                      width: `${columnWidths.itemNo}px`,
                      minWidth: `${columnWidths.itemNo}px`
                    }}
                  >
                    {itemData?.requisitionNo === "" ? (
                      <AsyncSelect
                        cacheOptions
                        value={{
                          value: row?.ItemNo,
                          label: row?.ItemNo
                        }}
                        options={itemOptions}
                        isDisabled={
                          itemData?.eye === true
                        }
                        loadOptions={loadOptions}
                        onChange={(selectedOption) =>
                          handleInputChange(row._rowKey || row.srno, index,
                            "ItemNo",
                            selectedOption?.label
                          )
                        }
                        defaultOptions={itemOptions}
                        onMenuScrollToBottom={loadMoreOptions}
                        styles={{
                          ...poCompactSelectStyles("itemNo"),
                          container: (base) => ({
                            ...base,
                            width: "100%"
                          }),
                          control: (base) => ({
                            ...base,
                            width: "100%",
                            minWidth: 0
                          })
                        }}
                        menuPortalTarget={document.body}
                      />
                    ) : (
                      <input
                        className="p-2"
                        disabled
                        value={row?.ItemNo}
                        style={{
                          width: "100%",
                          boxSizing: "border-box"
                        }}
                      />
                    )}
                  </td>

                  {/* Description */}
                  <td
                    className="m-0 p-0"
                    style={{
                      width: `${columnWidths.description}px`,
                      minWidth: `${columnWidths.description}px`
                    }}
                  >
                    {itemData?.requisitionNo === "" ? (
                      // <Tooltip text={row.itemDescription}>
                      <AsyncSelect
                        cacheOptions
                        value={{
                          value: row?.itemDescription,
                          label: row?.itemDescription
                        }}
                        isDisabled={
                          itemData?.eye === true
                        }
                        options={descriptionOptions}
                        loadOptions={loadDescOptions}
                        onChange={(selectedOption) =>
                          handleInputChange(row._rowKey || row.srno, index,
                            "itemDescription",
                            selectedOption?.label
                          )
                        }
                        defaultOptions={descriptionOptions}
                        onMenuScrollToBottom={
                          loadMoreDescOptions
                        }
                        styles={{
                          ...poCompactSelectStyles(
                            "description"
                          ),
                          container: (base) => ({
                            ...base,
                            width: "100%"
                          }),
                          control: (base) => ({
                            ...base,
                            width: "100%",
                            minWidth: 0
                          })
                        }}
                        menuPortalTarget={document.body}
                      />
                      // </Tooltip>
                    ) : (
                      <input
                        className="p-2"
                        disabled
                        value={row?.itemDescription}
                        style={{
                          width: "100%",
                          boxSizing: "border-box"
                        }}
                      />
                    )}
                  </td>

                  {/* Item Specs */}
                  <td
                    className="m-0 p-0"
                    style={{
                      width: `${columnWidths.specification}px`,
                      minWidth: `${columnWidths.specification}px`
                    }}
                  >
                    <textarea
                      className="p-2"
                      value={row?.specification}
                      onChange={(e) =>
                        handleInputChange(row._rowKey || row.srno, index,
                          "specification",
                          e.target.value
                        )
                      }
                      style={{
                        width: "100%",
                        boxSizing: "border-box",
                        resize: "none"
                      }}
                    />
                  </td>

                  {/* Qty */}
                  <td

                    className="m-0 p-0"
                    style={{
                      width: `${columnWidths.qty}px`,
                      minWidth: `${columnWidths.qty}px`
                    }}
                  >
                    <input
                      className="p-2"
                      id={`qty-${index}`}
                      onWheel={(e) => e.target.blur()}
                      type="number"
                      value={row?.qty}
                      onChange={(e) => handleInputChange(row._rowKey || row.srno, index, "qty", e.target.value)
                      }
                      onKeyDown={(e) => handleQtyKeyDown(e, index)}
                      style={{
                        width: "100%",
                        boxSizing: "border-box"
                      }}
                    />
                  </td>

                  {/* Unit Price */}
                  <td
                    className="m-0 p-0"
                    style={{
                      width: `${columnWidths.unitPrice}px`,
                      minWidth: `${columnWidths.unitPrice}px`
                    }}
                  >
                    <input
                      id={`qty-update-${index}`}
                      className="p-2"
                      onWheel={(e) => e.target.blur()}
                      type="number"
                      value={row?.baseAmount}
                      onChange={(e) =>
                        handleInputChange(row._rowKey || row.srno, index,
                          "baseAmount",
                          e.target.value
                        )
                      }
                      onKeyDown={(e) => {
                        handleQtyKeyDown(e, row.srno);
                      }}
                      style={{
                        width: "100%",
                        boxSizing: "border-box"
                      }}
                    />
                  </td>

                  {/* Discount */}
                  <td
                    className="m-0 p-0"
                    style={{
                      width: `${columnWidths.discount}px`,
                      minWidth: `${columnWidths.discount}px`
                    }}
                  >
                    <input
                      className="p-2"
                      onChange={(e) =>
                        handleInputChange(row._rowKey || row.srno, index,
                          "discount",
                          e.target.value
                        )
                      }
                      onKeyDown={preventNegativeSign}
                      type="number"
                      disabled={overallDiscount > 0}
                      value={row?.discount}
                      style={{
                        width: "100%",
                        boxSizing: "border-box"
                      }}
                    />
                  </td>


                  {/* Calculated Amount */}
                  <td
                    className="m-0 p-0"
                    style={{
                      width: `${columnWidths.calculatedAmount}px`,
                      minWidth: `${columnWidths.calculatedAmount}px`
                    }}
                  >
                    <input
                      className="p-2"
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      onKeyDown={preventNegativeSign}
                      value={row?.calculatedAmount ?? ""}
                      onChange={(e) =>
                        handleInputChange(row._rowKey || row.srno, index,
                          "calculatedAmount",
                          e.target.value
                        )
                      }
                      style={{
                        width: "100%",
                        boxSizing: "border-box"
                      }}
                    />
                  </td>

                  <td
                    className="m-0 p-0"
                    style={{
                      width: `${columnWidths.vat}px`,
                      minWidth: `${columnWidths.vat}px`
                    }}
                  >
                    <Select
                      className="flex-grow-1"
                      value={getVatSelectValue(row, vat)}
                      options={mapVatSelectOptions(vat)}
                      onChange={(selectedOption) =>
                        handleInputChange(row._rowKey || row.srno, index,
                          "vat",
                          selectedOption?.value
                        )
                      }
                      styles={{
                        control: (base) => ({
                          ...base,
                          width: "100%",
                          minWidth: 0
                        })
                      }}
                    />
                  </td>

                  {/* VAT Amount */}
                  <td
                    className="m-0 p-0"
                    style={{
                      width: `${columnWidths.vatAmount}px`,
                      minWidth: `${columnWidths.vatAmount}px`
                    }}
                  >
                    <input
                      className="p-2"
                      type="text"
                      value={row?.vatAmount ?? ""}
                          onKeyDown={preventNegativeSign}

                      onChange={(e) =>
                        handleInputChange(row._rowKey || row.srno, index,
                          "vatAmount",
                          e.target.value
                        )
                      }
                      style={{
                        width: "100%",
                        boxSizing: "border-box"
                      }}
                    />
                  </td>

                  {/* Amount */}
                  <td
                    className="m-0 p-0"
                    style={{
                      width: `${columnWidths.amount}px`,
                      minWidth: `${columnWidths.amount}px`
                    }}
                  >
                    <input
                      className="p-2"
                      disabled
                      type="text"
                      value={Number(
                        row?.amount || 0
                      ).toFixed(currencyPrecision || 0)}
                      style={{
                        width: "100%",
                        boxSizing: "border-box"
                      }}
                    />
                  </td>

                  {/* Inventory Qty */}
                  <td
                    className="m-0 p-0"
                    style={{
                      width: `${columnWidths.inventoryQty}px`,
                      minWidth: `${columnWidths.inventoryQty}px`
                    }}
                  >
                    <input
                      className="p-2"
                      disabled
                      type="text"
                      value={row?.stock || 0}
                      style={{
                        width: "100%",
                        boxSizing: "border-box"
                      }}
                    />
                  </td>

                  {/* Last Purchase Price */}
                  <td
                    className="m-0 p-0"
                    style={{
                      width: `${columnWidths.lastPurchasePrice}px`,
                      minWidth: `${columnWidths.lastPurchasePrice}px`
                    }}
                  >
                    <input
                      className="p-2"
                      disabled
                      type="text"
                      value={row?.avgPrice || 0}
                      style={{
                        width: "100%",
                        boxSizing: "border-box"
                      }}
                    />
                  </td>

                </tr>
              ))}
            </tbody>
          </table>
        )}
        {itemData?.requisitionNo === '' ? (
          <div className="d-flex gap-5">
            <button className="mainbtn  mt-4 gap-3" onClick={addNewRow}>
              <div>Add</div> <IoAddSharp color="#fff" className="center mt-1 mx-2" />{' '}
            </button>
          </div>
        ) : (
          ''
        )}
      </div>

      <div className="d-flex justify-content-between boxs">
        <div className="d-flex gap-2">
          <div className="totalhead center">Total Amount</div>
          <div className="field">{parseFloat(calculatedTotal)?.toFixed(currencyPrecision) || '---'}</div>
        </div>
        <div>
          <div className="totalhead center">_</div>
        </div>
        <div className="d-flex gap-2">
          <div className="totalhead center">Total Discount</div>
          <div className="field">{parseFloat(discountAmount)?.toFixed(currencyPrecision) || '---'}</div>
        </div>
        <div>
          <div className="totalhead center">=</div>
        </div>
        <div className="d-flex gap-2">
          <div className="totalhead center">After Discount</div>
          <div className="field">{(calculatedTotal - discountAmount)?.toFixed(currencyPrecision) || '---'}</div>
        </div>
        <div>
          <div className="totalhead center">+</div>
        </div>
        <div className="d-flex gap-2">
          <div className="totalhead center">Total Vat</div>
          <div className="field">{parseFloat(vatAmount)?.toFixed(currencyPrecision) || '---'}</div>
        </div>
        <div>
          <div className="totalhead center">=</div>
        </div>
        <div className="d-flex gap-2">
          <div className="totalhead center">Net Amount</div>
          <div className="field">{parseFloat(grandTotal)?.toFixed(currencyPrecision) || '---'}</div>
        </div>
      </div>
    </div>
  );
};

export default UpdateItemGrid;